






































































































































































































import "./goal-setup.less";
import Vue from "vue";
import moment from "moment-timezone";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";
import RoleSelector from "./defined-role-selector.vue";
import GradeSelector from "./defined-grade-selector.vue";
import DefinedColorPicker from "./../common/defined-color-picker.vue";
import UserAvatar from "../common/user-avatar.vue";
let _ = require("lodash");

export default Vue.extend({
  name: "goal-setup",
  components: {
    "defined-role-selector": RoleSelector,
    "defined-grade-selector": GradeSelector,
    DefinedColorPicker,
    VueTagsInput,
    UserAvatar,
  },
  props: {
    goal: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Target Name",
            trigger: "blur",
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Target Name to max 40 characters. Thanks!",
            trigger: "blur",
          },
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Target Description to max 1,200 characters. Thanks!",
            trigger: "blur",
          },
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags",
          },
        ],
        grades: [
          {
            required: true,
            message: "Please define the status scales",
          },
        ],
        calculationOption: [
          {
            required: true,
            type: "number",
            message: "Please select a display option",
            trigger: "blur",
          },
        ],
        members: [
          {
            type: "array",
            required: true,
            message: "Please select a member",
            validator: (rule, value, callback) => {
              if (value && value.filter((member) => member.selected === true).length > 0) {
                callback();
              } else {
                callback(new Error("Error!"));
              }
            },
          },
        ],
        timeline: [
          {
            required: true,
            message: "Please input the Target Timeline",
          },
          {
            validator(rule, value, callback, source, options) {
              let errors = [];
              if (value[0] === "") {
                errors.push("Please input the Target Timeline");
              }

              callback(errors);
            },
          },
        ],
      },
      gradeRules: {
        name: [
          {
            required: true,
            message: "*",
            trigger: "change",
          },
          {
            type: "string",
            max: 20,
            message: "Max 20 characters.",
            trigger: "change",
          },
        ],
        from: [
          {
            type: "number",
            required: true,
            message: "*",
            trigger: "change",
          },
        ],
        color: [
          {
            type: "string",
            required: true,
            message: "*",
            trigger: "change",
          },
        ],
      },
      memberRules: {
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "change",
          },
        ],
      },
      activePage: "",
      tag: "",
      tags: [],
      currentGoal: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: [],
        gradeModel: null,
        calculationOption: NaN,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: [],
        grades: [],
        members: [],
        teams: [],
        completed: false,
      },
    };
  },
  watch: {
    showModal(newVal) {
      this.gotoPage("details");

      if (newVal === true) {
        this.currentGoal.name = this.goal.name;
        this.currentGoal.description = this.goal.description;
        this.currentGoal.hashTags = this.goal.hashTags;
        this.currentGoal.hashTagList = this.currentGoal.hashTags ? JSON.parse(this.currentGoal.hashTags) : [];
        this.currentGoal.timezoneOffset = this.goal.timezoneOffset ? this.goal.timezoneOffset : new Date().getTimezoneOffset();
        this.currentGoal.timezoneName = this.goal.timezoneName ? this.goal.timezoneName : moment.tz.guess();
        this.currentGoal.timeline = this.goal.timeline;
        this.currentGoal.calculationOption = this.goal.calculationOption;
        this.currentGoal.gradeModel = this.goal.gradeModel;
        this.currentGoal.grades = this.currentGoal.gradeModel ? JSON.parse(this.currentGoal.gradeModel) : [];
        this.currentGoal.completed = this.goal.completed;

        let context = this as any;
        this.currentGoal.members = context.activeUsers.map((user) => {
          let result = Object.assign({}, user);

          let member = _.find(this.goal.members, function (member) {
            return user.memberId === member.memberId;
          });

          result.selected = !!member;
          result.role = !!member ? member.role : null;
          result.originalRole = !!member ? member.role : null;

          return result;
        });

        if (context.teams) {
          this.currentGoal.teams = context.teams.map((team) => {
            let result = Object.assign({}, team);

            let selectedTeam = _.find(this.goal.teams, function (item) {
              return item.teamId === team.id;
            });

            result.selected = !!selectedTeam;

            return result;
          });
        }

        let hiddenTeams = this.goal.teams.filter((item) => !context.teams || context.teams.filter((team) => team.id == item.teamId).length == 0);
        if (hiddenTeams.length > 0) {
          this.currentGoal.teams = this.currentGoal.teams.concat(
            hiddenTeams.map((item) => {
              return { id: item.teamId, name: item.teamName, selected: true, hidden: true, members: item.teamMembers };
            })
          );
        }
      }
    },
  },
  computed: {
    ...mapGetters("billing", ["activeUsers"]),
    ...mapGetters("goal", ["currentGoalInviteRoles", "canEdit", "calculationOptions"]),
    ...mapState("team", ["teams"]),
    showModal(): boolean {
      return this.showEditor;
    },
    timeframeChanged(): any {
      return this.goal.id && JSON.stringify(this.goal.timeline) != JSON.stringify(this.currentGoal.timeline);
    },
    getDurationString(): any {
      let timeline = this.currentGoal.timeline;
      if (timeline != null && timeline.length == 2) {
        let end = moment(timeline[1]);
        let start = moment(timeline[0]);

        let duration = end.diff(start, "days");
        return `You will accomplish this goal in: ${duration} Day(s)`;
      } else {
        return "";
      }
    },
    detailsCompleted(): any {
      let goal = this.currentGoal;
      return goal.name != null && goal.hashTagList.length > 0 && goal.timeline.length === 2;
    },
    measurementCompleted(): any {
      return this.currentGoal.calculationOption >= 0 && this.currentGoal.grades.length > 0;
    },
    membersCompleted(): any {
      return true;
    },
    teamsCompleted(): any {
      return true;
    },
  },
  created() {
    this.$store.dispatch("team/getMyTeams", {});
  },
  methods: {
    handleSelectDefinedGrade(item) {
      this.currentGoal.grades = item.grades.map((grade) => {
        return Object.assign({}, grade);
      });
    },
    handleRemoveGrade(grade) {
      for (var i = 0; i < this.currentGoal.grades.length; i++) {
        if (this.currentGoal.grades[i] === grade) {
          this.currentGoal.grades.splice(i, 1);
        }
      }
    },
    handleAddGrade() {
      this.currentGoal.grades.push({ name: "", color: "#ED4014", from: null });
    },
    getToValue(grades, index) {
      let to = NaN;
      if (index - 1 >= 0) {
        to = grades[index - 1].from === null || isNaN(grades[index - 1].from) ? NaN : grades[index - 1].from - 1;
      } else {
        to = 100;
      }

      return isNaN(to) ? " " : `% to ${to} %`;
    },
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    tagsChanged(newTags) {
      this.currentGoal.hashTagList = newTags;
      (this.$refs.SetupForm as any).validateField("hashTagList");
    },
    checkMember(member) {
      member.selected = !member.selected;
    },
    checkTeam(team) {
      team.selected = !team.selected;
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.SetupForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let timeline = this.currentGoal.timeline;

          if (this.currentGoal.grades && this.currentGoal.grades.length > 0) {
            this.currentGoal.grades[this.currentGoal.grades.length - 1].from = 0;
          }

          let goalDto = {
            id: this.goal.id,
            name: this.currentGoal.name,
            description: this.currentGoal.description,
            hashTags: JSON.stringify(this.currentGoal.hashTagList),
            calculationOption: this.currentGoal.calculationOption,
            gradeModel: JSON.stringify(this.currentGoal.grades),
            timezoneOffset: this.currentGoal.timezoneOffset,
            timezoneName: this.currentGoal.timezoneName,
            startDate: timeline && timeline.length === 2 ? timeline[0] : null,
            endDate: timeline && timeline.length === 2 ? timeline[1] : null,
            completed: this.currentGoal.completed,
          };

          goalDto[this.goal.id ? "updatedMembers" : "members"] = this.currentGoal.members
            .filter((member) => member.selected === true)
            .map((member) => {
              return { memberId: member.memberId, role: member.role, accepted: true };
            });

          goalDto["teams"] = this.currentGoal.teams
            .filter((team) => team.selected === true)
            .map((team) => {
              return { teamId: team.id };
            });

          let actionName = this.goal.id ? "goal/update" : "goal/create";
          let context = this;
          context.$store.dispatch(actionName, { data: goalDto }).then((response) => {
            context.$emit("cancel");
            context.$emit("saved");
            target.disabled = false;
          });
        } else {
          let fields = (form as any).fields.filter((field) => field.validateState === "error");
          if (fields != null && fields.length > 0) {
            let page = fields[0].$el.closest(".tab-content-wrap");
            if (page != null) {
              let pageName = page.getAttribute("name");
              this.gotoPage(pageName);
            }
          }

          target.disabled = false;
        }
      });
    },
    handlerWizardStep(forward) {
      let steps = ["details", "measurement", "members", "teams"];
      let nextStepIndex = _.findIndex(steps, (step) => step === this.activePage) + (forward ? 1 : -1);
      this.gotoPage(steps[nextStepIndex]);
    },
    gotoPage(name) {
      this.activePage = name;
    },
  },
});
